import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"]

  initialize () { 
    let _this = this,
        fields = [];

    if (_this.hasFormTarget) { 
      let form = _this.formTarget;

      fetch(form.dataset.id + ".json")
      .then(data => {return data.json();})
      .then(json =>{
        fields = json;
        console.log("json: ", json);
      })


      form.addEventListener("turbo:submit-start", function (event) { 
        event.detail.formSubmission.stop();
        let new_field = {}; 


        console.log(event.detail.formSubmission);

        const formData = new FormData(form);

        new_field["id"] = formData.get("field_id");
        new_field["title"] = formData.get("title");
        new_field["type"] = formData.get("type");

        fields.push(new_field);

        fetch(form.dataset.id, {
          method: "PUT",
          headers: {
            "X-CSRF-Token": document.head.querySelector("meta[name=csrf-token]")?.content,
            'Content-Type': 'application/json',
            Accept: "text/vnd.turbo-stream.html"
          },
          credentials: "same-origin",
          body: JSON.stringify({ form: { fields: fields }}), 
        }).then (response => response.text())
        .then(function(html) {
          form.closest("md-dialog").close();
          
          Turbo.renderStreamMessage(html);
        });

      });

    }

  }

}